"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ProvidersList_1 = __importDefault(require("./ProvidersList"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var BlockWithGames_1 = __importDefault(require("./BlockWithGames"));
var SearchByProvider = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var searchProviderId = '';
    var providers = [];
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var push = (0, navigation_1.useRouter)().push;
    var onClickProviderInDesktop = (0, react_1.useCallback)(function (providerId) {
        // dispatch(actions.setVisibleGamesCount(12))
        // if (Number(searchProviderId) === providerId)
        //   dispatch(actions.setProviderId(null))
        // else dispatch(actions.setProviderId(providerId))
    }, []);
    var onClickProviderInMobile = (0, react_1.useCallback)(function (providerId) {
        push("/providers/".concat(providerId === null || providerId === void 0 ? void 0 : providerId.toLowerCase()));
    }, [push]);
    var onClickProvider = (0, react_1.useCallback)(function (providerId) {
        if (breakpoints.mobile || breakpoints.tablet)
            onClickProviderInMobile(providerId);
        else
            onClickProviderInDesktop(providerId);
    }, [
        breakpoints.mobile,
        breakpoints.tablet,
        onClickProviderInDesktop,
        onClickProviderInMobile,
    ]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(ProvidersList_1.default, { selectedProviderId: searchProviderId, onItemClick: onClickProvider, providers: providers }),
        !breakpoints.mobile && !breakpoints.tablet && (react_1.default.createElement(BlockWithGames_1.default, { gameCardPlaceholder: gameCardPlaceholder }))));
};
exports.default = SearchByProvider;
